<template>
  <div class="bg">
    <div class="tabsBox">
      <el-tabs v-model="tabActiveName" @tab-click="tabsClick">
        <el-tab-pane label="大阪" name="Osaka"></el-tab-pane>
        <el-tab-pane label="東京" name="Tokyo"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-select v-model="state" placeholder="選んでください">
            <el-option label="保留予定" value="保留予定"></el-option>
            <el-option label="入荷確認" value="确认入库"></el-option>
            <el-option label="出荷指示" value="出荷指示"></el-option>
            <el-option label="出荷確認" value="确认出荷"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-select v-model="searchColumn" :placeholder="$t('message.placeholderColumn')" clearable>
            <el-option v-for="(column, index) in columnList" :key="index" :label="column.label" :value="column.value"></el-option>
          </el-select>
        </div>
        <div class="search_item" v-if="searchColumn !== ''">
          <el-input v-model="columnKeyword" :placeholder="$t('message.placeholderKeyword')"></el-input>
        </div>
        <div class="search_btn" @click="screening">{{$t('message.searchBtnText')}}</div>
      </div>
      <div class="add_btn" @click="showAddDialog"><img class="add_icon" src="@/assets/addIcon.svg" />{{$t('message.createCargoTable')}}</div>
    </div>
    <div class="content">
      <div class="tableBox">
        <el-table id="goodsList" :data="goodsList"  style="width: 100%" stripe size="small"
         header-cell-class-name="tableHeader" cell-class-name="tableBodyer" v-loading="loading" border height="100%">
          <el-table-column :resizable="false" prop="index" label="番号" width="65"></el-table-column>
          <el-table-column :resizable="false" prop="HWBH" label="貨物番号" min-width="120"></el-table-column>
          <el-table-column :resizable="false" prop="MDD" label="目的地" min-width="100"></el-table-column>
          <el-table-column :resizable="false" prop="NUM" label="個数" width="100"></el-table-column>
          <el-table-column :resizable="false" prop="RKFS" label="入庫方式" min-width="110"></el-table-column>
          <el-table-column :resizable="false" prop="KH" label="荷主様" min-width="100"></el-table-column>
          <el-table-column :resizable="false" prop="BLLY" label="保留理由" min-width="120"></el-table-column>
          <el-table-column :resizable="false" prop="BLYD" label="保留予定" width="110"></el-table-column>
          <el-table-column :resizable="false" prop="RKR" label="入庫日" width="110"></el-table-column>
          <el-table-column :resizable="false" label="入荷確認" min-width="120">
            <template slot-scope="scope">
              <a v-if="!scope.row.QRRK" class="operation_a_blue" @click="inStorageConfirm(scope.row.ID)">作成</a>
              <span v-else>{{scope.row.QRRK}}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="出荷指示" min-width="150">
            <template slot-scope="scope">
              <a v-if="scope.row.QRRK && !scope.row.CHZS" class="operation_a_blue" @click="outStorageInstructions(scope.row.ID)">作成</a>
              <span v-else>{{scope.row.CHZS}}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="CHR" label="出荷日" min-width="110"></el-table-column>
          <el-table-column :resizable="false" label="出荷確認" min-width="120">
            <template slot-scope="scope">
              <a v-if="scope.row.CHZS && !scope.row.QRCH" class="operation_a_blue" @click="outStorageConfirm(scope.row.ID)">作成</a>
              <span v-else>{{scope.row.QRCH}}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="添付ファイル" width="120">
            <template slot-scope="scope">
              <a class="operation_a_blue" @click="showUploadDialog(scope.row)">見る{{scope.row.filesNumber}}</a>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="" width="120">
            <template slot-scope="scope">
              <a class="operation_a_blue" target="_blank" :href="http + '/pdf/WlKu?ID=' + scope.row.ID">書き出し専用</a>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="" width="120">
            <template slot-scope="scope">
              <a class="operation_a_blue" target="_blank" :href="http + '/pdf/Shoulingshu?ID=' + scope.row.ID">受領書書き出し</a>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="" width="100" v-if="state !== '确认出荷'">
            <template slot-scope="scope">
              <el-button class="operation_btn updateBtn" type="text" size="small" v-if="!scope.row.QRCH" @click.native.prevent="updateReservedCargo(scope.row)"></el-button>
              <el-button class="operation_btn delBtn" type="text" size="small" v-if="!scope.row.QRCH" @click.native.prevent="delReservedCargo(scope.row.ID)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="page_no" :page-sizes="pageSizes" :page-size="page_size" layout="total, sizes, prev, pager, next"
        :total="totalSize" class="tablePage">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="showDialog" :title="$t('message.createCargoTable')" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="60%">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item"><span class="dialog_item_title">貨物番号</span><el-input class="dialog_item_input" v-model="goodsInfo.HWBH" :disabled="goodsInfo.ID !== 0"></el-input></div>
          <div class="dialog_item"><span class="dialog_item_title">個数</span><el-input class="dialog_item_input" v-model="goodsInfo.NUM" type="number"></el-input></div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item"><span class="dialog_item_title">荷主様</span><el-input class="dialog_item_input" v-model="goodsInfo.KH" :disabled="goodsInfo.ID !== 0"></el-input></div>
          <div class="dialog_item">
            <span class="dialog_item_title">入庫方式</span>
            <el-select v-model="goodsInfo.RKFS" style="flex-grow: 1;" :disabled="goodsInfo.ID !== 0">
              <el-option v-for="item in storageWay[tabActiveName]" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item"><span class="dialog_item_title">目的地</span><el-input class="dialog_item_input" v-model="goodsInfo.MDD"></el-input></div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item"><span class="dialog_item_title">保留理由</span><el-input class="dialog_item_input" v-model="goodsInfo.BLLY"></el-input></div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item"><span class="dialog_item_title">入荷確認</span><el-input class="dialog_item_input" v-model="goodsInfo.QRRK" :disabled="goodsInfo.ID !== 0"></el-input></div>
          <div class="dialog_item">
            <span class="dialog_item_title">入庫日</span>
            <el-date-picker class="dialog_item_input" v-model="goodsInfo.RKR" type="date" style="flex-grow: 1;" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="goodsInfo.ID !== 0"></el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="confirmFilIn">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showInStorage" title="入庫日" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="30%">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">入庫日</span>
            <el-date-picker class="dialog_item_input" v-model="outStorageTime" type="date" style="flex-grow: 1;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">入庫确认</span>
            <el-input class="dialog_item_input" v-model="outstoragePeople" style="flex-grow: 1;"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showOutStorage = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="outStorage">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showOutStorage" title="出荷日" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="30%">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">出荷日</span>
            <el-date-picker class="dialog_item_input" v-model="outStorageTime" type="date" style="flex-grow: 1;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item" v-if="outStorageState === 'outStorageConfirm'">
            <span class="dialog_item_title">出荷確認</span>
            <el-input class="dialog_item_input" v-model="outstoragePeople" style="flex-grow: 1;"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showOutStorage = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="outStorage">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="uploadDialog" title="添付ファイル" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="40%">
      <div>
        <div class="dialog_row">
          <div class="dialog_item" style="display: flex;justify-content: center;">
            <el-upload ref="upload" :action="uploadUrl" :file-list="fileList" :on-preview="previewFile" :on-success="uploadSuccess" :on-remove="uploadRemove">
              <el-button slot="trigger" size="small" type="primary">選択</el-button>
            </el-upload>
          </div>
          <div class="dialog_item" style="display: flex;flex-direction: column;align-items: center;">
            <div v-for="(file, index) in fileList" :key="index">
              <span>{{file.name}}</span>
              <el-button type="text" size="small" style="margin-left: 30px;" @click="downLoadAttachmentFile(file)">{{$t('message.download')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getReservedCargo, setReservedCargo, uploadImg, imgSrc, reservedBingFile, HTTPS, delReservedCargo, loadMultipleFiles } from '@/api/getData'
  export default {
    name: 'reservedCargoManagement',
    data () {
      const columnList = [
        {
          label: '貨物番号',
          value: 'HWBH'
        }, {
          label: '目的地',
          value: 'MDD'
        }, {
          label: '入庫方式',
          value: 'RKFS'
        }, {
          label: '荷主様',
          value: 'KH'
        }, {
          label: '入庫日',
          value: 'RKR'
        }, {
          label: '保留理由',
          value: 'BLLY'
        }, {
          label: '出荷指示',
          value: 'CHZS'
        }, {
          label: '出荷確認',
          value: 'QRCH'
        }
      ]
      return {
        tabActiveName: 'Osaka',
        storageWay: {
          Osaka: ['KIX', '篠陸デバン', 'CFS集荷'],
          Tokyo: ['NRT', '大田デバン', 'CFS集荷']
        },
        state: '确认入库',
        columnList: columnList,
        searchColumn: '', // 搜索行关键字
        columnKeyword: '', // 搜索关键字
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 50, 100, 200, 500],
        totalSize: 0,
        loading: false,
        goodsList: [],
        showDialog: false,
        goodsInfo: {
          ID: 0,
          HWBH: '', // 貨物番号
          NUM: 0, // 个数
          KH: '', // 荷主様
          RKFS: '', // 入庫方式
          MDD: '', // 目的地
          BLLY: '', // 保留理由
          QRRK: '', // 确认入库
          RKR: '', // 入庫日
          STATE: '确认入库',
          BLUSER: ''
        },
        showInStorage: false,
        showOutStorage: false,
        outStorageState: '',
        outStorageId: 0,
        outStorageTime: '',
        outstoragePeople: '',
        uploadDialog: false,
        uploadFIle: [],
        fileList: []
      }
    },
    created() {
      let param = this.$store.state.JHSS_reservedCargoManage_param
      if (param.DDD) this.tabActiveName = param.DDD
      if (param.STATE) this.state = param.STATE
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      if (param.HWBH) {
        this.columnKeyword = param.HWBH
        this.searchColumn = 'HWBH'
      }
      if (param.MDD) {
        this.columnKeyword = param.MDD
        this.searchColumn = 'MDD'
      }
      if (param.RKFS) {
        this.columnKeyword = param.RKFS
        this.searchColumn = 'RKFS'
      }
      if (param.KH) {
        this.columnKeyword = param.KH
        this.searchColumn = 'KH'
      }
      if (param.RKR) {
        this.columnKeyword = param.RKR
        this.searchColumn = 'RKR'
      }
      if (param.BLLY) {
        this.columnKeyword = param.BLLY
        this.searchColumn = 'BLLY'
      }
      if (param.CHZS) {
        this.columnKeyword = param.CHZS
        this.searchColumn = 'CHZS'
      }
      if (param.QRCH) {
        this.columnKeyword = param.QRCH
        this.searchColumn = 'QRCH'
      }
      this.getReservedCargo(param)
    },
    methods: {
      async getReservedCargo (param) {
        this.loading = true
        param = param || {}
        param.DDD = this.tabActiveName
        param.STATE = this.state
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getReservedCargo(param)
        this.loading = false
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          // console.log(res.data)
          let index = (this.page_no - 1) * this.page_size
          this.totalSize = res.data.num
          this.goodsList = res.data.dt.map(item => {
            item.index = ++index
            item.filesNumber = !item.FILELST ? '(0)' : '(' + item.FILELST.split(',').length + ')'
            return item
          })
          this.$store.commit('setReservedCargoManage_param', param)
        }
      },
      tabsClick (tab, event) {
        // console.log(tab.name) insteadShipping / directShipment // 查询上架管理
        this.getReservedCargo()
      },
      // 筛选
      screening () {
        this.searchFun()
      },
      sizeChange (val) {
        this.page_size = val
        this.searchFun()
      },
      currentChange (val) {
        this.searchFun(val)
      },
      searchFun (val) {
        if (this.searchColumn && !this.columnKeyword) {
          this.$message(this.$t('message.placeholderKeyword'))
          return
        }
        this.page_no = val || 1
        let param = {}
        if (this.searchColumn && this.columnKeyword) param[this.searchColumn] = this.columnKeyword
        this.getReservedCargo(param)
      },
      // 点击创建在库表
      showAddDialog () {
        this.goodsInfo = this.$options.data().goodsInfo // 在库表数据初始化
        this.showDialog = true
      },
      updateReservedCargo (obj) {
        this.goodsInfo = obj
        this.showDialog = true
      },
      async confirmFilIn () {
        if (!this.goodsInfo.HWBH) {
          this.$message('貨物番号')
        } else if (!this.goodsInfo.NUM) {
          this.$message('个数')
        } else if (!this.goodsInfo.KH) {
          this.$message('荷主様')
        } else if (!this.goodsInfo.RKFS) {
          this.$message('入庫方式')
        } else if (!this.goodsInfo.MDD) {
          this.$message('目的地')
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading'
          })
          let param = this.goodsInfo
          if (!this.goodsInfo.RKR && !this.goodsInfo.QRRK) {
            param.STATE = '保留予定'
            param.BLUSER = this.$store.state.JHSS.personalUserid
          } else {
            param.RKUSER = this.$store.state.JHSS.personalUserid
          }
          param.DDD = this.tabActiveName
          if (this.goodsInfo.ID !== 0) {
            param = {
              ID: this.goodsInfo.ID,
              STATE: '修改',
              MDD: this.goodsInfo.MDD,
              NUM: this.goodsInfo.NUM,
              BLLY: this.goodsInfo.BLLY
            }
          }
          let res = await setReservedCargo(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
          } else if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.$message.success('Operation is successful')
            this.page_no = 1
            this.showDialog = false
            this.searchFun()
          }
        }
      },
      inStorageConfirm (id) {
        this.outStorageId = id
        this.outStorageState = 'inStorageConfirm'
        this.outStorageTime = ''
        this.outstoragePeople = ''
        this.showInStorage = true
      },
      outStorageInstructions (id) {
        this.outStorageId = id
        this.outStorageState = 'outStorageInstructions'
        this.outStorageTime = ''
        this.showOutStorage = true
      },
      outStorageConfirm (id) {
        this.outStorageId = id
        this.outStorageState = 'outStorageConfirm'
        this.outStorageTime = ''
        this.outstoragePeople = ''
        this.showOutStorage = true
      },
      async outStorage () {
        if (this.outStorageState === 'inStorageConfirm' && !this.outstoragePeople) {
          this.$message('入荷確認！')
        } else if (!this.outStorageTime) {
          this.$message('出荷日！')
        } else if (this.outStorageState === 'outStorageConfirm' && !this.outstoragePeople) {
          this.$message('出荷確認！')
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading'
          })
          var param = { ID: this.outStorageId }
          if (this.outStorageState === 'inStorageConfirm') {
            param.QRRK = this.outstoragePeople
            param.RKUSER = this.$store.state.JHSS.personalUserid
            param.RKR = this.outStorageTime
            param.STATE = '确认入库'
          } else if (this.outStorageState === 'outStorageInstructions') {
            // 出荷指示
            param.CHZS = this.outStorageTime + ' ' + this.$store.state.JHSS.personalAccount
            param.CHUSER = this.$store.state.JHSS.personalUserid
            param.STATE = '出荷指示'
          } else if (this.outStorageState === 'outStorageConfirm') {
            // 出荷確認
            param.QRCH = this.outstoragePeople
            param.CKUSER = this.$store.state.JHSS.personalUserid
            param.CHR = this.outStorageTime
            param.STATE = '确认出荷'
          }
          let res = await setReservedCargo(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
          } else if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.$message.success('Operation is successful')
            this.page_no = 1
            this.showOutStorage = false
            this.showInStorage = false
            this.searchFun()
          }
        }
      },
      showUploadDialog (obj) {
        this.outStorageId = obj.ID
        if (!obj.FILELST) {
          this.uploadFIle = []
          this.fileList = []
        } else {
          let namelist = obj.FILELST.split(',')
          let oldnamelist = obj.GUDING1.split(',')
          this.uploadFIle = namelist.map((item, index) => {
            return { newname: item, name: oldnamelist[index] }
          })
          this.fileList = namelist.map((item, index) => {
            return { newname: item, url: imgSrc(item), name: oldnamelist[index] }
          })
        }
        this.uploadDialog = true
      },
      previewFile (file) {
        window.open(file.url)
      },
      // 上传成功
      async uploadSuccess (file) {
        // console.log('receiptSuccess', file)
        if (file.result !== '1') {
          this.$message.error('UPLOAD ERROR')
        } else {
          this.uploadFIle.push({ newname: file.data.filename, name: file.data.fileoldname })
          let filename = this.uploadFIle.map(item => {
            return item.newname
          })
          let fileoldname = this.uploadFIle.map(item => {
            return item.name
          })
          let param = { ID: this.outStorageId, FILELST: filename.join(','), GUDING1: fileoldname.join(',') }
          let res = await reservedBingFile(param)
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
          } else {
            this.$message.success('UPLOAD SUCCESS')
            this.fileList = this.uploadFIle.map(item => {
              return { newname: item.newname, url: imgSrc(item.newname), name: item.name }
            })
            this.getReservedCargo()
          }
        }
      },
      // 移除成功
      async uploadRemove (file) {
        console.log('returnReceiptRemove', file)
        let uploadFIle = this.uploadFIle
        for (let i = 0; i < uploadFIle.length; i++) {
          if (file.name === uploadFIle[i].name) {
            uploadFIle.splice(i, 1)
          }
        }
        this.uploadFIle = uploadFIle
        let filename = this.uploadFIle.map(item => {
          return item.newname
        })
        let fileoldname = this.uploadFIle.map(item => {
          return item.name
        })
        let param = { ID: this.outStorageId, FILELST: filename.join(','), GUDING1: fileoldname.join(',') }
        let res = await reservedBingFile(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          this.$message.success('DELETE SUCCESS')
          this.fileList = this.uploadFIle.map(item => {
            return { newname: item.newname, url: imgSrc(item.newname), name: item.name }
          })
          this.getReservedCargo()
        }
      },
      // 删除
      delReservedCargo (id) {
        let _this = this
        this.$confirm('', _this.$t('message.deleteCargoTable'), {
          // showClose: false,
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          center: true,
          callback: async (action) => {
            if (action === 'confirm') {
              const loading = _this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              })
              let param = { ID: id }
              let res = await delReservedCargo(param)
              loading.close()
              if (res.status !== 200) {
                _this.$message.error('network error：' + res.status)
              } else if (res.data.result !== '1') {
                _this.$message.error(res.data.message)
              } else {
                _this.$message.success('Delete Success')
                this.getReservedCargo()
              }
            }
          }
        })
      },
      // 单个附加文件下载
      async downLoadAttachmentFile (file) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = {
          FILENAME: file.newname,
          FILETYPE: file.name,
          DOWNLOADUSER: this.$store.state.JHSS.personalUserid
        }
        let res = await loadMultipleFiles(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // console.log(res.data.data)
          window.open(imgSrc(res.data.data))
        }
        loading.close()
      }
    },
    computed: {
      uploadUrl () {
        return uploadImg()
      },
      http () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
</style>
